import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/sessions/session-materials-list.html";

import Shared from "Sources/shared";
import MissionMaterialCategory from "./mission-material-category";

class SessionMaterialsList
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.onSetUpMaterialsDone = options.onSetUpMaterialsDone;
    this.hasRendered = false;
    this.allCategories = [];
    this.allMaterials = [];
    this.materials = [];
    this.categories = [];

  }

  static setUpSessionMaterialsList(options, materialList)
  {
    let instance = new SessionMaterialsList(options);
    instance.render();
    Shared.getAllMaterialCategories().then(categories => {
      instance.allCategories = categories;
      //console.log(instance.allCategories);
      Shared.getAllMaterials().then(materials => {
        instance.setUpAllMaterials(materials);
        if(materialList)
          instance.updateMaterials(materialList);

        instance.onSetUpMaterialsDone();
      });
    })
    instance.setUpEventListeners();
    return instance;
  }

  setUpCategories(materials)
  {
    //if(materials.count > 0)
    //{
      materials.forEach( material =>
      {
        let categoryKey = this.allMaterials.find(mat => mat.key === material.materialKey).materialCategoryKey;
        if(categoryKey)
        {
          this.setUpCategory(categoryKey);
        }

      });
    //}

  }

  setUpEventListeners()
  {

  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.append(this.$element);
    LanguageManager.applyLocale(this.$element);
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  setUpAllMaterials(materials)
  {
    this.allMaterials = materials;
  }

  updateMaterialsFromGroups(groups)
  {
    this.materials = [];
    this.categories = [];

    $("#materials-wrapper").empty();

    let that = this;
    groups.forEach(group => {
      if(utils.isNotNull(group.mission))
      {
        this.addMaterialsToList(group.mission.mission.missionMaterialList);
      }
    });

    if(this.materials.length > 0)
    {
      $(".materials-placeholder-text").hide();
    }
    else
    {
      $(".materials-placeholder-text").show();
    }
  }

  updateMaterials(materials)
  {
    this.materials = [];
    this.categories = [];

    $("#materials-wrapper").empty();
    this.addMaterialsToList(materials);

    if(this.materials.length > 0)
    {
      $(".materials-placeholder-text").hide();
    }
    else
    {
      $(".materials-placeholder-text").show();
    }
  }

  addMaterialsToList(materials)
  {
    this.setUpCategories(materials);
    materials.forEach( material =>
    {

      if (this.allMaterials.find(mat => mat.key === material.materialKey))
      {
        let newMaterial = {
          materialKey: material.materialKey,
          amount: material.amount,
          name: this.allMaterials.find(mat => mat.key === material.materialKey).name,
          categoryKey: this.allMaterials.find(mat => mat.key === material.materialKey).materialCategoryKey
        }

        let oldMaterial = this.materials.find(oldMaterial => oldMaterial.materialKey === newMaterial.materialKey);
        if (utils.isUndefined(oldMaterial)) {
          this.materials.push(newMaterial);
          this.setUpMaterial(newMaterial);
        } else {
          this.addToMaterialAmount(newMaterial);
        }
      }
    });
  }

  addToMaterialAmount(newMaterial)
  {
    this.materials.forEach( material => {
      if(material.materialKey === newMaterial.materialKey)
      {
        //todo: keep infinite if other occurrence is infinite
        if(material.amount === 0)
        {
          let amountString = LanguageManager.getValueForKey("mission_material.infinite_btn");
          $("#" + material.materialKey).text(material.name + " (" + amountString + ")");
          //$("#" + material.materialKey).text(material.name);
        }
        else
        {
          material.amount += newMaterial.amount;
          $("#" + material.materialKey).text(material.name + " (" + material.amount + ")");
          //$("#" + material.materialKey).text(material.name);
        }

      }
    });
  }

  setUpMaterial(materialObj)
  {

    if(this.allMaterials.find(material => material.key === materialObj.materialKey))
    {

      let amountString = "";
      if(materialObj.amount === 0)
      {
        amountString = LanguageManager.getValueForKey("mission_material.infinite_btn");
      }
      else
      {
        amountString = materialObj.amount;
      }

      //let el = "<p class='material-list-item' id='" + materialObj.materialKey + "'>" + materialObj.name + " (" + amountString + ")</p>";
      let el = "<p class='material-list-item' id='" + materialObj.materialKey + "'>" + materialObj.name +", </p>";
      $(".category-" + materialObj.categoryKey).append($(el));
    }
    else
    {
      //material does not exist in allMaterials
    }
  }

  setUpCategory(categoryKey)
  {
    let materialCategory = this.categories.find(cat => cat.key === categoryKey);

    if(!materialCategory)
    {
      //create new category
      let category = this.allCategories.find(cat => cat.key === categoryKey);
      if(!utils.isNullOrEmpty(category) || !utils.isUndefined(category))
      {
        this.categories.push(category);

        let that = this;
        let $catEl = $(
          "<div class='materials-category open'>" +
            "<p class='material-category-title'>" +
          "<span><button class=\"icon-btn open-category-btn\">\n" +
          "  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9.105\" height=\"5.171\" viewBox=\"0 0 9.105 5.171\">\n" +
          "    <g id=\"icn_dropdown\" transform=\"translate(-59.299 -230.925)\">\n" +
          "      <path id=\"Path_41\" data-name=\"Path 41\" d=\"M67.8,230.925a.552.552,0,0,1,.551.383.563.563,0,0,1-.123.658l-3.947,3.947a.591.591,0,0,1-.857,0l-3.947-3.947a.562.562,0,0,1-.122-.658.552.552,0,0,1,.551-.383Z\" transform=\"translate(0 0)\"></path>\n" +
          "    </g>\n" +
          "  </svg>\n" +
          "</button></span>" +
          "<span>" + category.name + "</span>" +
          "</p>" +
            "<div class='category-materials category-" + category.key + "'>" +
            "</div>" +
          "</div>");
        $catEl.find(".open-category-btn").on("click", function(e)
        {
          that.toggleMatCategory($catEl);
        });
        $("#materials-wrapper").append($catEl);
      }

    }
  }

  toggleMatCategory($catEl)
  {
    if($catEl.hasClass("open"))
    {
      $catEl.removeClass("open");
    }else{
      $catEl.addClass("open");
    }

  }




  //NEW STUFF
/*
  setUpCategories(allCategories, allMaterials) {
    allCategories.forEach(function (category) {

      let categoryObject = MissionMaterialCategory.setUpMissionMaterialCategory({
        container: ".materials-wrapper",
        category: {
          key: category.key,
          localizationKey: category.localizationKey,
          name: category.name,
        },
        materials: this.getMaterialsForCategory(category.key),
        selected: false,
        showCheckmarks: false,
      })
      this.materialCategories.push(categoryObject);
    });
  }

  getSelectedMaterials() {
    let selectedMaterials = [];

    this.materialCategories.forEach(category => {
      this.materials = category.getSelectedMaterials();
      this.materials.forEach(material => {
        selectedMaterials.push({materialKey: material.material.key, amount: material.material.amount});
      });
    });

    return selectedMaterials;
  }

  getMaterialsForCategory(categoryKey) {
    let categoryMaterials = [];
    this.allMaterials.forEach(material => {
      if (material.materialCategoryKey === categoryKey) {
        //if the material was already selected, add amount
        if (originalMission) {
          let originalMat = originalMission.missionMaterialList.find(originalMat => originalMat.materialKey === material.key);
          if (originalMat) {
            material.selected = true;
            material.amount = originalMat.amount;
          }
        }
        categoryMaterials.push(material);
      }
    });

    return categoryMaterials;
}

 */

}

export default SessionMaterialsList;



// WEBPACK FOOTER //
// ./app/js/components/session-materials-list.js